import { ONBOARDING_SECTIONS, TAX_SECTIONS, type EmployeeSetupResponse, type TaxSetupResponse } from './types';
import { validatePersonal } from './validation';

/** The furthest section the employee may open. Sections the employee must fill in come first; the rest are read-only review. */
export function reachableSectionIndex(setup: EmployeeSetupResponse): number {
  const p = setup.personal;
  const personalComplete =
    Object.keys(
      validatePersonal({
        firstName: p.firstName ?? '',
        lastName: p.lastName ?? '',
        phone: p.phone ?? '',
        gender: p.gender ?? '',
        dateOfBirth: p.dateOfBirth ?? '',
      }),
    ).length === 0;
  if (!personalComplete) return 0;
  if (!setup.residenceAddress) return 1;
  return ONBOARDING_SECTIONS.length - 1;
}

/** The furthest tab the employee may open: the federal answer comes first, then the state, then the two read-only tabs. */
export function reachableTaxIndex(t: TaxSetupResponse): number {
  const federalDone = t.federal.status !== 'NotStarted' || t.federal.historical !== null;
  if (!federalDone) return 0;
  // With no state known yet, or only a territory (EPN has no state election for it), there is nothing to answer, so the employee is not held up on it.
  const stateDone = t.state.status !== 'NotStarted' || t.state.options.every((o) => o.ruleKind === 'NotYetSupported');
  return stateDone ? TAX_SECTIONS.length - 1 : 1;
}
